import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  useEffect(() => {
    console.log('=== PROTECTED ROUTE ===');
    console.log('1. État du chargement:', loading);
    console.log('2. Utilisateur actuel:', user);
    console.log('3. Rôle requis:', requiredRole);
    
    if (user) {
      console.log('4. Rôle de l\'utilisateur:', user.role);
      if (requiredRole) {
        console.log('5. Vérification du rôle requis:', user.role === requiredRole);
      }
    }
  }, [user, loading, requiredRole]);

  if (loading) {
    console.log('6. Affichage du chargeur...');
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    console.log('7. Aucun utilisateur connecté, redirection vers /login');
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    console.warn(`8. Accès refusé: Rôle requis: ${requiredRole}, Rôle actuel: ${user.role}`);
    // Rediriger vers le tableau de bord par défaut si le rôle n'est pas autorisé
    return <Navigate to="/dashboard" replace />;
  }

  console.log('9. Accès autorisé, affichage du composant enfant');
  return <>{children}</>;
};

export default ProtectedRoute;
